(() => {
  const headerShell = document.querySelector('.dd-header-shell--home');

  if (!headerShell) return;

  document.body.classList.add('dd-transparent-header-enabled');

  const setAnnouncementOffset = () => {
    const headerSection = headerShell.closest('.section-header');
    let announcementHeight = 0;

    if (headerSection) {
      let section = headerSection.previousElementSibling;

      while (section) {
        if (section.classList.contains('announcement-bar-section')) {
          announcementHeight += section.offsetHeight;
        }

        section = section.previousElementSibling;
      }
    }

    document.documentElement.style.setProperty('--dd-announcement-bar-height', `${announcementHeight}px`);
  };

  const updateScrolledState = () => {
  const isScrolled = window.scrollY > 20;

  headerShell.classList.toggle('dd-header-shell--scrolled', isScrolled);
  document.body.classList.toggle('dd-header-at-top', !isScrolled);
  document.body.classList.toggle('dd-header-is-scrolled', isScrolled);
};

  const updateMenuState = () => {
    const hasOpenDesktopMenu = Boolean(headerShell.querySelector('header-menu details[open]'));
    const hasOpenDrawer = Boolean(headerShell.querySelector('.menu-drawer-container[open]'));

    headerShell.classList.toggle('dd-header-shell--menu-open', hasOpenDesktopMenu);
    headerShell.classList.toggle('dd-header-shell--drawer-open', hasOpenDrawer);
  };

  setAnnouncementOffset();
  updateScrolledState();
  updateMenuState();

  window.addEventListener('resize', setAnnouncementOffset, { passive: true });
  window.addEventListener('scroll', updateScrolledState, { passive: true });
  headerShell.addEventListener('toggle', updateMenuState, true);

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(setAnnouncementOffset);
    document.querySelectorAll('.announcement-bar-section').forEach((section) => {
      resizeObserver.observe(section);
    });
  }
})();
